import { NotesSectionStyles } from './NotesSection.types'

const makeStyles = (): NotesSectionStyles => ({
	noteText: {
		fontSize: '18px'
	}
})

export default makeStyles
